import React from 'react'

import { observer } from 'mobx-react'

import { useStores } from 'stores'
import ContentLoader from 'common/ContentLoader'

import InvoiceOrderItemTable from './InvoiceOrderItemTable'

export default observer(({ activated, caseId, caseCurrency }) => {
  const { pageResourceStore, invoiceStore } = useStores()

  const {
    PageResource: { case: resource = {} },
  } = pageResourceStore
  const {
    Table: {
      data: { order: { orders = [] } = {} },
      loading,
    },
  } = invoiceStore

  React.useEffect(() => activated && invoiceStore.fetchTable(caseId), [invoiceStore, caseId, activated])

  return (
    <div className="position-relative">
      <ContentLoader show={loading} />
      {!!orders.length &&
        orders.map((orderItem, index) => (
          <div key={index} className="invoice-order-block margin-bot-20 col-12">
            <InvoiceOrderItemTable resource={resource} orderItem={orderItem} caseCurrency={caseCurrency} />
          </div>
        ))}
      {!orders.length && resource.NoInvoiceYet}
    </div>
  )
})
